import type { PressableProps } from "react-native";
import { Pressable } from "react-native";

export const ThemedPressable = ({
  style,
  children,
  disabled,
  ...props
}: PressableProps) => {
  return (
    <Pressable style={style} {...props} disabled={disabled}>
      {children}
    </Pressable>
  );
};
